import { html, TemplateResult } from 'lit-element';
import getString from '../strings';
import { ActionBarHandler, KatDataGridActionBar } from './action-bar';

export class SelectionActionBarHandler implements ActionBarHandler {
  private selectedRowCount: number;

  constructor(rowsLength: number) {
    this.selectedRowCount = rowsLength;
  }

  renderBarContent(container: KatDataGridActionBar): TemplateResult {
    return html`
      <span class="row-count-container">
        <kat-badge
          label="${`${this.selectedRowCount} ${getString('dg-selected')}`}"
          type="info"
          part="selection-actionbar-row-count"
        ></kat-badge>
      </span>
      <div class="action-bar-slot">
        <slot name="selection-actionbar"></slot>
      </div>
      <button
        class="close-button"
        aria-label="${getString('dg-close')}"
        @click="${() =>
          container.dispatchEvent(new Event('action-bar-closed'))}"
        part="selection-actionbar-close"
      >
        <kat-icon name="close" size="small"></kat-icon>
      </button>
    `;
  }

  firstUpdated(container: Element): void {
    this.dropDownToDropUp(container);
  }

  // Remove this code when the dropdown component from figma has been implemented
  // A temporary fix for current drop down options to stick to the top
  // Had to use interval as the options are not loaded right away firstUpdated is triggered
  dropDownToDropUp(container: Element) {
    let tries = 100;
    const timer = setInterval(() => {
      tries = tries - 1;
      const katDropDowns = container.querySelectorAll('kat-dropdown-button');
      if (katDropDowns.length > 0) {
        katDropDowns.forEach(button => {
          button.shadowRoot
            .querySelector('.options')
            .setAttribute('style', 'bottom:100%; margin-bottom: 2px;');
        });
        clearInterval(timer);
      }
      if (tries <= 0) {
        clearTimeout(timer);
      }
    }, 200);
  }
}
